import React from 'react';

import { PagingInfo, ResultsPerPage } from '@elastic/react-search-ui';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  searchPageInfo: {
    composes: 'flexRow spaceBetween stretchSelf center',
    marginBottom: theme.spacing(4),
  },
  resultPerPage: {
    '& .sui-select': {
      width: 200,
    },
    '& .sui-select__control': {
      width: '100%',
      padding: [12, 6],
      border: '.0625rem solid #b2b2bf',
      borderRadius: '.25rem',
      background: '#fff url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4Ij48c3R5bGU+PC9zdHlsZT48cGF0aCBkPSJNMTYuNTM3IDguMjVINy40NjNhMS4zNTggMS4zNTggMCAwMC0xLjExIDIuMjUxbDQuMzU0IDQuNzdhMS41MyAxLjUzIDAgMDAyLjE4NC4wNGw0LjcxOC00Ljc3YTEuMzU3IDEuMzU3IDAgMDAtMS4wNzItMi4yOTF6IiBmaWxsPSIjNDQ0NTYwIi8+PC9zdmc+) no-repeat right .75rem center',
      backgroundSize: '1.125rem 1.125rem',
      color: '#111236',
      lineHeight: '1.125rem',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none',
    },
    '& .sui-select__indicators': {
      display: 'none',
    },
  },
}));

const SearchPageInfo = () => {
  const classes = useStyles();

  return (
    <div className={classes.searchPageInfo}>
      <PagingInfo />
      <ResultsPerPage className={classes.resultPerPage} />
    </div>
  );
}
export default SearchPageInfo;
